import React from 'react'

import {t} from '@lib/helpers'
import {certificationBadgeImages, zipWithImage} from './constant'

export default function Certification() {
  const badges = zipWithImage(
    t('pages.partnerAws.certification.badges'),
    certificationBadgeImages
  )

  return (
    <section className='PartnerAws__certification'>
      <div className='PartnerAws__inner PartnerAws__certification__header'>
        <p className='PartnerAws__caption PartnerAws__gradient-text'>
          {t('pages.partnerAws.certification.caption')}
        </p>
        <h2 className='PartnerAws__section-title'>
          {t('pages.partnerAws.certification.title')}
        </h2>
        <p className='PartnerAws__certification__description'>
          {t('pages.partnerAws.certification.description')}
        </p>
      </div>

      <div className='PartnerAws__certification__badges'>
        {badges.map((badge, index) => (
          <div className='PartnerAws__certification__badge' key={index}>
            {!!badge.image && <img src={badge.image} alt={badge.label} />}
            <p className='PartnerAws__certification__badge__label'>
              {badge.label}
            </p>
          </div>
        ))}
      </div>

      <div className='PartnerAws__certification__wave' />
    </section>
  )
}
